import { render } from "./inventory_valuation.vue?vue&type=template&id=50bb6e1b&scoped=true"
import script from "./inventory_valuation.vue?vue&type=script&lang=js"
export * from "./inventory_valuation.vue?vue&type=script&lang=js"

import "./inventory_valuation.vue?vue&type=style&index=0&id=50bb6e1b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50bb6e1b"]])

export default __exports__